<div>
  <app-header></app-header>
  <div class="main-section">
    <div class="left-sidebar">
      <app-sidebar></app-sidebar>
    </div>
    <ngx-loading-bar ref="http"></ngx-loading-bar>
    <div class="main-content">
      <div>
        <div *ngIf="loader.value$ | async" class="overlay"></div>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer [showFull]="false" [isLogin]="true"></app-footer>
</div>
